import { Link } from "react-router-dom";
import { Badge } from "./ui/badge";
import { Clock, Calendar, ArrowRight, Sparkles } from "lucide-react";
import type { BlogPost } from "../data/blogPosts";

const BlogCard = ({ post, featured = false }: { post: BlogPost; featured?: boolean }) => {
  const formattedDate = new Date(post.publishDate).toLocaleDateString("pt-BR", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });

  return (
    <Link to={`/blog/${post.slug}`} className="group block">
      <article
        className={`relative overflow-hidden rounded-xl border border-border/50 bg-card glow-card ${
          featured ? "md:col-span-2" : ""
        }`}
      >
        <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-transparent to-primary/3 opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
        <div className="absolute top-0 left-0 right-0 h-px shimmer" />

        <div className={`relative p-6 ${featured ? "md:p-8" : ""}`}>
          <div className="mb-3 flex flex-wrap items-center gap-2">
            <Badge variant="secondary" className="bg-primary/10 text-primary border-primary/20 text-xs font-medium backdrop-blur-sm">
              {post.category}
            </Badge>
            {post.featured && (
              <Badge className="bg-primary text-primary-foreground text-xs font-medium inline-flex items-center gap-1">
                <Sparkles className="h-3 w-3" /> Destaque
              </Badge>
            )}
          </div>

          <h2
            className={`font-display font-bold text-foreground group-hover:gradient-text transition-all duration-300 mb-3 leading-tight ${
              featured ? "text-2xl md:text-3xl" : "text-lg md:text-xl"
            }`}
          >
            {post.title}
          </h2>

          <p className="text-muted-foreground text-sm leading-relaxed mb-5 line-clamp-3">
            {post.excerpt}
          </p>

          <div className="flex items-center justify-between text-xs text-muted-foreground">
            <div className="flex items-center gap-4">
              <span className="flex items-center gap-1.5">
                <Calendar className="h-3.5 w-3.5 text-primary/60" />
                {formattedDate}
              </span>
              <span className="flex items-center gap-1.5">
                <Clock className="h-3.5 w-3.5 text-primary/60" />
                {post.readTime} min
              </span>
            </div>
            <span className="flex items-center gap-1 text-primary font-medium opacity-0 translate-x-2 transition-all duration-300 group-hover:opacity-100 group-hover:translate-x-0">
              Ler <ArrowRight className="h-3.5 w-3.5" />
            </span>
          </div>
        </div>
      </article>
    </Link>
  );
};

export default BlogCard;
